import * as React from "react";
import { redirect, useLoaderData, useLocation } from "react-router-dom";
import { Gender, Patron } from "../AccountSummaryAlerts";
import { OBRSettingHolder, OBRSettingsProvider } from "../OBRSettings";
import { OBRForm, OBRFormInput } from "../OBRForm";
import { LoaderData } from "./account/MyAccount";
import { LocationConfigurationHolder } from "../LocationConfiguration";
import { GlobalConfigHolder } from "../GlobalConfig";
import { DefaultValues } from "react-hook-form";
import { useAccount } from "../Account";
export interface PatronWithFields {
  patron: Patron;
  fields: { [key: number]: string };
}

export const createAccountPageLoader = async () => {
  const locationConfiguration =
    await LocationConfigurationHolder.fetchLocationConfiguration();
  const { obrEnabled } = await GlobalConfigHolder.fetchGlobalConfig();
  if (!locationConfiguration.pacSettings.obrEnabled || !obrEnabled) {
    return redirect("/404");
  }
  return await OBRSettingHolder.getConfig();
};

export const CreateAccountPage: React.FC = () => {
  const location = useLocation();
  const { isAuthenticated, patron } = useAccount();
  const { smsGateways, obrConfiguration } = useLoaderData() as LoaderData<
    typeof createAccountPageLoader
  >;

  const searchParams = new URLSearchParams(location.search);
  const googleId = searchParams.get("googleId");
  const firstName = searchParams.get("firstName");
  const lastName = searchParams.get("lastName");
  const gender = searchParams.get("gender");
  const googleEmail = searchParams.get("email");

  const defaults: DefaultValues<OBRFormInput> = {
    patron: {},
    fields: {},
  };

  if (isAuthenticated && patron) {
    defaults.patron.lastName = patron.lastName;
    defaults.patron.email = patron.email;
    defaults.patron.email2 = patron.email2;
    defaults.patron.email3 = patron.email3;
    defaults.patron.phone = patron.phone;
    defaults.patron.address1 = patron.address1;
    defaults.patron.city = patron.city;
    defaults.patron.state = patron.state;
    defaults.patron.zipcode = patron.zipcode;
    defaults.patron.issuingBranch = patron.issuingBranch;
    // Notice Preference Defaults
    defaults.patron.arrivedHoldNotificationTypes = patron.arrivedHoldNotificationTypes;
    defaults.patron.automaticRenewalNotificationTypes = patron.automaticRenewalNotificationTypes;
    defaults.patron.overdueNotificationTypes = patron.overdueNotificationTypes;
    defaults.patron.finalOverdueNotificationTypes = patron.finalOverdueNotificationTypes;
    defaults.patron.expiredCardNotificationTypes = patron.expiredCardNotificationTypes;
    defaults.patron.cancelledHoldNotificationTypes = patron.cancelledHoldNotificationTypes;
    defaults.patron.friendlyWarningNotificationTypes = patron.friendlyWarningNotificationTypes;

    // TODO make a note in dev notes, these property assignments likely haven't worked for some time
    // $("#" + this.id + "_PHONE1").val(currentUser.phoneNumber);
    // $("#" + this.id + "_ADDRESS").val(currentUser.address.address);
    // $("#" + this.id + "_CITY").val(currentUser.address.city);
    // $("#" + this.id + "_STATE").val(currentUser.address.province);
    // $("#" + this.id + "_ZIPCODE").val(currentUser.address.postalCode);
  } else if (googleId && googleEmail) {
    defaults.patron.googleId = googleId;
    defaults.patron.email = googleEmail;
    defaults.patron.googleEmail = googleEmail;
    if (firstName) {
      defaults.patron.firstName = firstName;
    }
    if (lastName) {
      defaults.patron.lastName = lastName;
    }
    if (gender) {
      if (gender.toLowerCase() === Gender.Male.toLowerCase()) {
        defaults.patron.gender = Gender.Male;
      }
      if (gender.toLowerCase() === Gender.Female.toLowerCase()) {
        defaults.patron.gender = Gender.Female;
      }
    }
  }

  if (isAuthenticated && patron) {
    defaults.patron.responsibleAgencyNumber = patron.guid;
  }

  return (
    <>
      <OBRSettingsProvider>
        <OBRForm
          obrConfiguration={obrConfiguration}
          smsGateways={smsGateways}
          defaultValues={defaults}
        ></OBRForm>
      </OBRSettingsProvider>
    </>
  );
};
